import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// Runtime build marker for debugging - visible in browser console
console.log("UTILITYDEZK_BUILD", {
  mode: import.meta.env.MODE,
  demoMode: import.meta.env.VITE_DEMO_MODE,
  environment: import.meta.env.VITE_APP_ENVIRONMENT,
  buildTime: import.meta.env.VITE_BUILD_TIME || new Date().toISOString(),
  buildVersion: import.meta.env.VITE_BUILD_VERSION || 'unknown',
  timestamp: Date.now()
});

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
